import { render, staticRenderFns } from "./outlierAdd.vue?vue&type=template&id=24d3a3a0&scoped=true&"
import script from "./outlierAdd.vue?vue&type=script&lang=js&"
export * from "./outlierAdd.vue?vue&type=script&lang=js&"
import style0 from "./outlierAdd.vue?vue&type=style&index=0&id=24d3a3a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3a3a0",
  null
  
)

export default component.exports